export const REVENUE = 'Revenue';
export const REVENUE_BY_SERVICE = 'RevenueByService';
export const REVENUE_BY_PRODUCT = 'RevenueByProduct';
export const PLAN = 'Plan';
export const AVERAGE_CHECK = 'AverageCheck';
export const AVERAGE_OCCUPANCY = 'AverageOccupancy';
export const RECORDS_ALL = 'RecordsAll';
export const RECORDS_CANCELED = 'RecordsCanceled';
export const RECORDS_CONFIRMED = 'RecordsConfirmed';
export const RECORDS_WAITING = 'RecordsWaiting';
export const RECEIPTS_TO_CASH_REGISTER = 'ReceiptsToCashRegister';
export const RECORD_CREATED_COUNT = 'RecordCreatedCount';
export const RECORD_CREATED_AMOUNT = 'RecordCreatedAmount';
export const FIRST_CLIENTS = 'FirstClients';
export const SECOND_CLIENTS = 'SecondClients';
export const RETURNABILITY = 'Returnability';
export const AVERAGE_BILL_BY_FIRST_CLIENTS = 'AverageBillByFirstClients';
export const AVERAGE_BILL_BY_SECOND_CLIENTS = 'AverageBillBySecondClients';
export const CLIENTS_WIDGET_ID = 'Clients';

export const REVENUE_TEXT = 'Выполнено услуг на сумму';
export const REVENUE_BY_SERVICE_TEXT = 'Доход по услугам';
export const REVENUE_BY_PRODUCT_TEXT = 'Доход по товарам';
export const PLAN_TEXT = 'План';
export const AVERAGE_CHECK_TEXT = 'Средний чек';
export const AVERAGE_OCCUPANCY_TEXT = 'Средняя заполненность';
export const RECORDS_ALL_TEXT = 'Всего записей';
export const RECORDS_CANCELED_TEXT = 'Отмененных';
export const RECORDS_CONFIRMED_TEXT = 'Завершенных';
export const RECORDS_WAITING_TEXT = 'Незавершенных';
export const RECEIPTS_TO_CASH_REGISTER_TEXT = 'Поступлений в кассы';
export const CLIENTS_WIDGET_TEXT = 'Клиентов';
